import { createFeatureSelector } from '@ngrx/store';
import { ProcessesPopState } from './processes-pop.model';
import { FEATURE_NAME } from './processes-pop.constant';

export const selectProcessesPopState = createFeatureSelector<ProcessesPopState>(FEATURE_NAME);

